import { parse } from 'date-fns';
import { zonedTimeToUtc, format } from 'date-fns-tz';
import config from '@/config';

export default function formatDateFilter(
  date,
  formatStr = config.dateTimeOutputFormat,
  withZoneChange = true
) {
  const parsedDate = parse(date, config.dateTimeInputFormat, new Date());
  const zonedDate = withZoneChange
    ? zonedTimeToUtc(parsedDate, config.defaultTimezone)
    : null;
  /* console.log('INPUT DATE >>>', date);
  console.log('DATE FNS PARSE >>>', parsedDate);
  console.log('DATE FNS + TIMEZONE >>>', zonedDate);
  console.log('OUTPUT >>>', format(zonedDate, config.dateTimeOutputFormat));
  console.log('--------------'); */
  return zonedDate
    ? format(zonedDate, formatStr)
    : format(parsedDate, formatStr);
}
